import {useQuery} from '@tanstack/react-query'
import {B2BMetricsRepository} from '../repositories/B2BMetricsRepository.ts'
import {AuthenticationRepository} from '../repositories/AuthenticationRepository.ts'

const b2bMetricsRepository = new B2BMetricsRepository(new AuthenticationRepository())

export const B2B_AGENCIES_QUERY_KEY = ['b2b-agencies'] as const

export function useB2BAgencies() {
    const query = useQuery({
        queryKey: B2B_AGENCIES_QUERY_KEY,
        queryFn: () => b2bMetricsRepository.getB2BAgencies(),
    })

    return {
        data: query.data,
        agencies: query.data?.agencies ?? [],
        facets: query.data?.facets,
        renewalThreshold: query.data?.renewalThreshold,
        isLoadingAgencies: query.isLoading,
        agenciesError: query.error,
    }
}
